// import { Message } from 'element-ui'
import { getDevOpsSpaceStageSelectmapApi, } from "@/server/tops/devOps";
import {
  getDevOpsSpaceSystemApi,
  getDevOpsSpaceAllUserListApi,
  getDevOpsSpaceAllStatusListApi,
  getDevOpsSpaceMenuListListApi,
  getDevOpsSpaceWorkOrderConfigApi
} from "@/server/tops/base";
import { GETDEVOPSSELECT, GETDEVOPSSYSTEM, GETDEVOPSUSERLIST, GETDEVOPSSTATUSLIST,  GETDEVOPSNENULIST, GETDEVOPSWORKORDERCONFIG} from './type';

export default {
  async [GETDEVOPSSELECT](context) {
    try {
      const ret = await getDevOpsSpaceStageSelectmapApi({ type: 'getallusers' })
      context.commit('setDevopsSelect', ret);
    } catch (error) {
      console.warn(error);
    }
  },
  async [GETDEVOPSSYSTEM](context) {
    try {
      const ret = await getDevOpsSpaceSystemApi()
      let res = context.commit('setDevopsSystem', ret);
    } catch (error) {
      console.warn(error);
    }
  },
  async [GETDEVOPSUSERLIST](context,params) {
    try {
      const ret = await getDevOpsSpaceAllUserListApi(params)
      let res = context.commit('setDevopsUserList', {data:ret.data,userType:params.userType});
    } catch (error) {
      console.warn(error);
    }
  },
  async [GETDEVOPSSTATUSLIST](context,params) {
    try {
      const ret = await getDevOpsSpaceAllStatusListApi(params)
      let res = context.commit('setDevopsStatusList', {data:ret.data,type:params.type});
    } catch (error) {
      console.warn(error);
    }
  },
  async [GETDEVOPSNENULIST](context,params) {
    try {
      const ret = await getDevOpsSpaceMenuListListApi(params)
      let res = context.commit('setDevopsMenuList', {data:ret.data});
    } catch (error) {
      console.warn(error);
    }
  },
  async [GETDEVOPSWORKORDERCONFIG](context,params) {
    try {
      const ret = await getDevOpsSpaceWorkOrderConfigApi(params)
      let res = context.commit('setDevopsWorkOrderConfigList', {data:ret.data});
    } catch (error) {
      console.warn(error);
    }
  },
  setToken:({commit},data)=>{
      commit('SET_TOKEN',data);
    },
    setUserInfo:({commit},data)=>{
      commit('SET_USER_INFO',data);
    },
    setMenuList:({commit},data)=>{
      commit('SET_MENU_LIST',data);
    },
}
